module.exports = __webpack_public_path__ + "fonts/iconfont.d3684c60.ttf";